const IMAGES = {
    kuwaitinput: require('./kuwaitinput.svg').default,
    bartone: require('./bartone.svg').default,
    bartoneGroupBill: require('./bartone.svg').default,
    union: require('./union2.svg').default,
    newsPaper: require('./newsPaper.svg').default,
    giftPaper: require('./gift2.svg').default,
    dialpad: require('./Dialpad2.svg').default,
    time: require('./time2.svg').default,

}

export default IMAGES;

